import { render, staticRenderFns } from "./AnnouncementEditor.vue?vue&type=template&id=43a78550&scoped=true&"
import script from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementEditor.vue?vue&type=style&index=0&id=43a78550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a78550",
  null
  
)

export default component.exports